/**
 * @generated SignedSource<<09e6e7bbcc88e2827a2e1145936d8b0d>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type mergedCell_nativeIssueTable$data = {
  readonly canHaveChildIssues?: boolean | null | undefined;
  readonly hasChildren?: boolean | null | undefined;
  readonly node?: {
    readonly issueId: string;
  } | null | undefined;
  readonly " $fragmentType": "mergedCell_nativeIssueTable";
};
export type mergedCell_nativeIssueTable$key = {
  readonly " $data"?: mergedCell_nativeIssueTable$data;
  readonly " $fragmentSpreads": FragmentRefs<"mergedCell_nativeIssueTable">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "isJscM2Enabled"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "projectKey"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "projectKeys"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "shouldQueryHasChildren"
    }
  ],
  "kind": "Fragment",
  "name": "mergedCell_nativeIssueTable",
  "selections": [
    {
      "condition": "shouldQueryHasChildren",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "args": [
            {
              "kind": "Variable",
              "name": "filterByProjectKeys",
              "variableName": "projectKeys"
            }
          ],
          "kind": "ScalarField",
          "name": "hasChildren"
        },
        {
          "args": [
            {
              "kind": "Variable",
              "name": "projectKey",
              "variableName": "projectKey"
            }
          ],
          "kind": "ScalarField",
          "name": "canHaveChildIssues"
        }
      ]
    },
    {
      "condition": "isJscM2Enabled",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "concreteType": "JiraIssue",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            {
              "kind": "ScalarField",
              "name": "issueId"
            }
          ]
        }
      ]
    }
  ],
  "type": "JiraIssueEdge"
};

(node as any).hash = "c511176f8f0a10f587c8dd02f36f186e";

export default node;
